import { getRouters } from '@/api/router'
import Layout from '@/layout/index'
import i18n from '@/lang'
import { menuData } from './menu.js'

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    indexPage: '',
    viewCache: {}
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = routes
    },

    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    SET_INDEX_PAGE: (state, indexPage) => {
      state.indexPage = indexPage
    },
    SET_VIEW_CACHE: (state, viewCache) => {
      state.viewCache = viewCache
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit, rootState }) {
      const type = process.env.VUE_APP_PREFIX === 'tbbaccess' ? 2 : 1
      const userName = rootState.user.name
      return new Promise(async (resolve) => {
        const requestData =
          type === 2
            ? menuData
            : await getRouters()
                .then((res) => {
                  return res.data || []
                })
                .catch(() => {
                  return []
                })
        
        // 如果用户是 tbbservice@mail.com，只保留首页路由
        if ((userName === 'tbbservice@mail.com'
        ||userName === 'servicetest@mail.com') && requestData.length > 0) {
          // 查找首页路由
          let serviceRouter = []
          
          serviceRouter = requestData.find(child => child.name === 'Service Center')
          console.log('serviceRouter',serviceRouter)
          const sdata = JSON.parse(JSON.stringify([serviceRouter]))
          const rdata = JSON.parse(JSON.stringify([serviceRouter]))
          const indexPage = serviceRouter.path
          const sidebarRoutes = filterAsyncRouter(sdata)
          const rewriteRoutes = filterAsyncRouter(rdata, false, true)
          rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', rewriteRoutes)
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
          commit('SET_INDEX_PAGE', indexPage)
          resolve(rewriteRoutes)
        } else if (requestData.length > 0) {
          // 正常用户的路由生成逻辑
          const sdata = JSON.parse(JSON.stringify(requestData))
          const rdata = JSON.parse(JSON.stringify(requestData))
          const isChild =
            requestData[0].children && requestData[0].children.length > 0
          const indexPage = isChild
            ? requestData[0].path + '/' + requestData[0].children[0].path
            : requestData[0].path
          const sidebarRoutes = filterAsyncRouter(sdata)
          const rewriteRoutes = filterAsyncRouter(rdata, false, true)
          rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', rewriteRoutes)
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
          commit('SET_INDEX_PAGE', indexPage)
          resolve(rewriteRoutes)
        } else {
          resolve([])
        }
      })
    },
    setViewCache({ commit }, viewCache) {
      console.log('viewCache', viewCache)
      commit('SET_VIEW_CACHE', viewCache)
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        route.component = loadView(route.component, route)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

// export const loadView = (view) => {
//   if (process.env.NODE_ENV === 'development') {
//     return (resolve) => require([`@/views/${view}`], resolve)
//   } else {
//     // 使用 import 实现生产环境的路由懒加载
//     return () => import(`@/views/${view}`)
//   }
// }

export const loadView = (view, route) => {
  const page = route?.page || 'pro'
  return (resolve) => {
    if (page === 'tbbaccess') {
      require([`@/tbbaccess/views/${view}`], resolve)
    } else {
      require([`@/views/${view}`], resolve)
    }
  }
}

export default permission
